import { render, staticRenderFns } from "./benefits-segmented-control.vue?vue&type=template&id=355a92fa&scoped=true"
import script from "./benefits-segmented-control.vue?vue&type=script&lang=js"
export * from "./benefits-segmented-control.vue?vue&type=script&lang=js"
import style0 from "./benefits-segmented-control.vue?vue&type=style&index=0&id=355a92fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a92fa",
  null
  
)

export default component.exports